import AddManuallyPage from "domains/liquidity/pages/AddManuallyPage/AddManuallyPage";

export default AddManuallyPage;
